import React from 'react';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import { NavLink } from 'react-router-dom';
import Icon from '@material-ui/core/Icon';

const ItemInfo = (props) => {
  const url = props.url;
  return (
    <div>
      {/* <NavLink to="/"><Icon id="back-icon">arrow_back_ios</Icon></NavLink> */}
      {/* {url ? (
        <div id="item-photo-container">
          <img id="item-photo" src={url} />
        </div>
      ) : null} */}
      <div
        id='item'
        className='item-container'
        style={{
          textAlign:
            (props.lang === 'ar') | (props.lang === 'qrAR')
              ? 'right '
              : 'left ',
        }}
      >
        <br />
        <div id='item-name' variant='title' gutterBottom>
          {props.name}
        </div>
        <Typography id='item-description' variant='caption' gutterBottom>
          {props.description}
        </Typography>
        {/*<p>Some info about the item, and other stuff too like ingredients and such</p>-->*/}

        <br />
      </div>
      <Divider className='hr' />
    </div>
  );
};
export default ItemInfo;



// WEBPACK FOOTER //
// ./src/components/ItemInfo.js